import template from './campaign-detail.html';
import controller from './campaign-detail.controller';

let campaignDetailComponent = {
  bindings: {},
  template,
  controller
};

export default campaignDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign-detail.component.js